import React, { useRef, useState, useEffect, useContext } from 'react';
import useOnScreen from '../../../hooks/useOnScreen';
import { FilterContext } from '../../../context/FilterContext';
import { useNavigate } from 'react-router-dom';

function Lampara({ data, index = 0 }) {
  const [show, setShow] = useState(false);
  const ref = useRef(null);
  const isVisible = useOnScreen(ref);
  const navigate = useNavigate();
  const fi = useContext(FilterContext);

  const comingSoon = data.nombre === 'AR1111';

  useEffect(() => {
    if (isVisible && !show) setShow(true);
  }, [isVisible]);

  const handleClick = () => {
    if (comingSoon) return;
    fi.dispatch({
      type: 'set_lamparas_filter',
      payload: { lamparas: [data.id] },
    });
    navigate('/productos');
  };

  return (
    <div
      ref={ref}
      onClick={handleClick}
      style={{ transitionDelay: `${(index % 4) * 80}ms` }}
      className={`group transition-all duration-700 ease-out ${
        comingSoon ? 'cursor-default' : 'cursor-pointer'
      } ${show ? 'translate-y-0 opacity-100' : 'translate-y-8 opacity-0'}`}
    >
      <div className="relative overflow-hidden rounded-2xl bg-ink-100">
        <div className="aspect-square w-full">
          <img
            src={require(`../../../assets/images/lamparas/${data.imagen}`)}
            alt={data.nombre}
            className={`h-full w-full object-cover transition-transform duration-700 ease-out ${
              comingSoon ? 'opacity-50' : 'group-hover:scale-110'
            }`}
          />
        </div>

        {comingSoon ? (
          <div className="absolute inset-0 flex items-center justify-center bg-ink/40 backdrop-blur-[2px]">
            <span className="rounded-full bg-white/90 px-4 py-1.5 text-xs font-medium uppercase tracking-wider2 text-ink">
              Próximamente
            </span>
          </div>
        ) : (
          <div className="absolute inset-0 bg-gradient-to-t from-ink/60 to-transparent opacity-0 transition-opacity duration-300 group-hover:opacity-100" />
        )}
      </div>
      <span className="mt-3 block text-sm font-medium tracking-wide text-ink">
        {data.nombre}
      </span>
    </div>
  );
}

export default Lampara;
